import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faBook, faStopwatch, faBell } from '@fortawesome/free-solid-svg-icons';
import featuresSectionStyles from './FeaturesSection.module.scss';

const FeaturesSection = () => (
  <section id="features-section" className={featuresSectionStyles.features} aria-labelledby="features-title">
    <div className={featuresSectionStyles.featuresTitle}>
      <h2 id="features-title" className={featuresSectionStyles.featuresHeading}>
        <span className={featuresSectionStyles.featuresHeadingMain}>Feature <span className={featuresSectionStyles.highlight}>Packed</span></span>
      </h2>
      <p className={featuresSectionStyles.featuresSubtitle}>
        <span className={featuresSectionStyles.highlightBrand}>mobiyo</span> is not just collecting customer reviews. It's an <span className={featuresSectionStyles.highlightAI}>intelligent AI-based assistant</span> helping you take action efficiently against your customers
      </p>
    </div>
    <div className={featuresSectionStyles.featuresContainer}>
      <div className={featuresSectionStyles.feature}>
        <div className={featuresSectionStyles.featureImageContainer}>
          <FontAwesomeIcon icon={faLightbulb} size="2x" aria-hidden="true" />
        </div>
        <div className={featuresSectionStyles.featureInfo}>
          <h3>Fetch Reviews</h3>
          <p>Automatically gather reviews from Google Play and Apple App Store</p>
        </div>
      </div>
      <div className={featuresSectionStyles.feature}>
        <div className={featuresSectionStyles.featureImageContainer}>
          <FontAwesomeIcon icon={faBook} size="2x" aria-hidden="true" />
        </div>
        <div className={featuresSectionStyles.featureInfo}>
          <h3>AI-Powered Responses</h3>
          <p>Craft intelligent and contextually appropriate responses</p>
        </div>
      </div>
      <div className={featuresSectionStyles.feature}>
        <div className={featuresSectionStyles.featureImageContainer}>
          <FontAwesomeIcon icon={faStopwatch} size="2x" aria-hidden="true" />
        </div>
        <div className={featuresSectionStyles.featureInfo}>
          <h3>Analytics Dashboard</h3>
          <p>Visualize review trends, user sentiment, and feedback analytics</p>
        </div>
      </div>
      <div className={featuresSectionStyles.feature}>
        <div className={featuresSectionStyles.featureImageContainer}>
          <FontAwesomeIcon icon={faBell} size="2x" aria-hidden="true" />
        </div>
        <div className={featuresSectionStyles.featureInfo}>
          <h3>Multi-language Support</h3>
          <p>Respond to customer reviews in multiple languages</p>
        </div>
      </div>
    </div>
  </section>
);

export default FeaturesSection; 
